import { useAbility } from '@cast/shared-ability-data-access';

export const useKentAbilities = () => {
  const [canViewOnboardingScript, canInstallCastAutoscaler] =
    useAbility().canMany([
      ['create', 'Clusters'],
      ['update', 'Clusters'],
    ]);
  const [canViewFeatures, canUpdateFeatures] = useAbility().canMany([
    ['view', 'ClusterKentFeatures'],
    ['update', 'ClusterKentFeatures'],
  ]);
  const canViewKarpenterSettings = useAbility().can(
    'view',
    'ClusterKentKarpenterSettings'
  );
  const [
    canEditRebalancingSchedule,
    canCreateRebalancingSchedule,
    canDeleteRebalancingSchedule,
  ] = useAbility().canMany([
    ['update', 'ClusterRebalancer'],
    ['create', 'ClusterRebalancer'],
    ['delete', 'ClusterRebalancer'],
  ]);

  return {
    canViewOnboardingScript,
    canViewFeatures,
    canUpdateFeatures,
    canViewKarpenterSettings,
    canInstallCastAutoscaler,
    canEditRebalancingSchedule,
    canCreateRebalancingSchedule,
    canDeleteRebalancingSchedule,
  };
};
